import { addMinutes, format, parse, startOfDay } from 'date-fns';

/** The wizard's minimum lead time, plus a little headroom so the default never fails validation. */
const DEFAULT_SCHEDULE_LEAD_MINUTES = 10;

/** A valid future slot: now + lead time, rounded up to the next 5 minutes. */
export const getDefaultScheduleSlot = (now: Date = new Date()): { date: Date; time: string } => {
  const target = addMinutes(now, DEFAULT_SCHEDULE_LEAD_MINUTES);
  const roundedMinutes = Math.ceil(target.getMinutes() / 5) * 5;
  const slot = new Date(target);
  slot.setMinutes(roundedMinutes, 0, 0);
  return { date: startOfDay(slot), time: format(slot, 'HH:mm') };
};

export const getCurrentScheduleTime = (): string => getDefaultScheduleSlot().time;

/** Normalize API `ScheduleTime` (ISO or HH:mm) into a wizard time slot. */
export const parseScheduleTimeValue = (value: string | null | undefined): string => {
  const raw = value?.trim();
  if (!raw) return getCurrentScheduleTime();

  if (/^\d{1,2}:\d{2}$/.test(raw)) {
    try {
      return format(parse(raw, 'HH:mm', new Date()), 'HH:mm');
    } catch {
      return raw;
    }
  }

  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    return format(parsed, 'HH:mm');
  }

  return getCurrentScheduleTime();
};
